// extracted by mini-css-extract-plugin
module.exports = {"embedded_form":"EmbeddedFrame_embedded_form__3zxHl"};